// Tier-2 <Switch> backed by AntD Switch (FORT-182). Clean boolean
// checked/onChange contract. Colour comes from the token-sourced AntD global
// theme — no raw values here.
import React from 'react';
import { Switch as AntSwitch } from 'antd';
import type { CommonProps } from './types';

export interface SwitchProps extends CommonProps {
  // A bare switch has no visible label when it lives in a table cell, so callers in
  // that position must name it for assistive tech.
  'aria-label'?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  loading?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  defaultChecked,
  onChange,
  disabled,
  loading,
  className,
  style,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
}) => (
  <AntSwitch
    checked={checked}
    defaultChecked={defaultChecked}
    onChange={(value) => onChange?.(value)}
    disabled={disabled}
    loading={loading}
    className={className}
    style={style}
    aria-label={ariaLabel}
    data-testid={dataTestId}
  />
);
